import * as R from "ramda";
import React from "react";
import { useSelector } from "react-redux";
import ButtonLoader from "src/components/ButtonLoader";
import { getResendInvite } from "src/reducers";
import type { AppState, UID } from "src/types";
import { InvitingUserButton } from "./cellRenderers/styles";

interface Props {
  text: string;
  uid: UID;
  handleClick: (e: React.MouseEvent) => void;
}

const InvitingUser = ({
  text,
  uid,
  handleClick,
}: Props): React.ReactElement => {
  const resendInvite = useSelector(({ app }: { app: AppState }) =>
    getResendInvite(app),
  );
  const loading = R.includes(uid, resendInvite);

  return (
    <InvitingUserButton loading={loading}>
      <ButtonLoader isLoading={loading} type="button" handleClick={handleClick}>
        {text}
      </ButtonLoader>
    </InvitingUserButton>
  );
};

export default InvitingUser;
